export default __webpack_public_path__ + "static/media/icon-negotiation-active.46627896.svg";